import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useConf } from "../../context/account/paramsAccount";
import { useError } from "../../context/erreur/erreurContext";
import { useOfflineMode } from "../../context/horsLigne/modeHorsLigneContext";
import { handleActivateOfflineMode } from "../../functions/HorsLigne/activeornotHl";
import { loadModeHorsligne } from "../../functions/HorsLigne/loadmodeHL";
import { redirection } from "../../functions/redirect";
import { Switch } from "@progress/kendo-react-inputs";
import {
    BottomNavigation,
    BottomNavigationSelectEvent,
} from "@progress/kendo-react-layout";
import {
    homeIcon,
    menuIcon,
} from "@progress/kendo-svg-icons";
import { ModalMenu } from "../modalMenu/modalMenu";
import { SVGIcon } from "@progress/kendo-react-common";
const IconHl: SVGIcon = {
    name: "onlineIcon",
    content: '<path d="M576 0c17.7 0 32 14.3 32 32l0 448c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-448c0-17.7 14.3-32 32-32zM448 96c17.7 0 32 14.3 32 32l0 352c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-352c0-17.7 14.3-32 32-32zM352 224l0 256c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32s32 14.3 32 32zM192 288c17.7 0 32 14.3 32 32l0 160c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-160c0-17.7 14.3-32 32-32zM96 416l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32s32 14.3 32 32z" />',
    viewBox: "0 0 640 512",
};

const items = [
    { svgIcon: homeIcon, text: "Accueil", selected: false },
    { svgIcon: IconHl, text: "Mode hors ligne" },
    { svgIcon: menuIcon, text: "Menu" },
];

export function Nav() {
    const location = useLocation();
    const { ifOffLineMode, toggleOfflineMode } = useOfflineMode();
    const [isOffLine, setIsOffLine] = useState(false)
    const { conf, setConf } = useConf()
    const navigate = useNavigate();
    const [listePresta, setListePresta]: any = useState()

    const checkPresta = () => {
        loadModeHorsligne('prestaHl',conf)
            .then(data => {
                if (data) {
                    const entetes = data.map((item: any) => item?.entete);
                    if (entetes) {
                        handleActivateOfflineMode(setConf, conf, toggleOfflineMode)
                        setListePresta(entetes)
                    }
                } else {
                    setListePresta(undefined)
                    redirection(navigate, "/mode-hors-ligne")
                }
            })
            .catch(error => console.error('Erreur lors du chargement des données hors ligne :', error));
    }
    const [selectedIndex, setSelectedIndex] = useState(
        items.findIndex((x) => x.selected === true)
    );
    const handleSelect = (e: BottomNavigationSelectEvent) => {
        if (selectedIndex === e.itemIndex) {
            if (selectedIndex !== 0 && selectedIndex !== 1 && selectedIndex === 2) {
                if (location.pathname === '/') {
                    setSelectedIndex(0)
                }
                if (location.pathname === '/mode-hors-ligne') {
                    setSelectedIndex(1)
                } else {
                    setSelectedIndex(-1)
                }
            } else {
                setSelectedIndex(-1)
            }

        } else {
            setSelectedIndex(e.itemIndex);
        }
    };
    useEffect(() => {
        if (selectedIndex === 0) {
            redirection(navigate, '/')
        } else if (selectedIndex === 1) {
            redirection(navigate, '/mode-hors-ligne')
        }
    }, [selectedIndex])
    useEffect(() => {
        if (location.pathname === '/') {
            setSelectedIndex(0)
        } else if (location.pathname === '/mode-hors-ligne') {
            setSelectedIndex(1)
        } else {
            setSelectedIndex(-1)
        }
    }, [location,])
    return (
        <div className="footer">
            <div className="containerRight">
                <Switch onChange={() => { ifOffLineMode ? checkPresta() : handleActivateOfflineMode(setConf, conf, toggleOfflineMode) }} checked={isOffLine} />
                <BottomNavigation
                    items={items.map((item, index) => ({
                        ...item,
                        selected: index === selectedIndex,
                    }))}
                    onSelect={handleSelect}
                />

                {
                    selectedIndex === 2 ? <ModalMenu
                        selectedIndex={selectedIndex}
                        handleSelect={handleSelect} ></ModalMenu> : ''
                }
            </div>
        </div>
    );
}
